module.exports = __webpack_public_path__ + "img/huojian.c513a977.png";